import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { IOptionFilter } from "@models/entity-models";
import { eRuleType } from "@models/enums";

@Kbo(CToken.OptionFilter)
export class OptionFilter extends RuleContainer implements IOptionFilter {
    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.optionFilter });
        this.dependsOn = [];
        this.dependsOnThis = [];
        this.fieldReferences = [];
    }

    public idTable: number;
    public source: string;
    public dbTable: string;
    public idOptionFilter: string;
    public level: number;
    public queryMode: string;
    public singleOptionBehavior: string;
    public dependsOn: string[];
    public dependsOnThis: string[];
    public fieldReferences: string[];
    public optimized: boolean;
    public visibleToChildren: boolean;
    public snapType: string;
    /**
     * Stores the last values of referenced fields on the client for optimization purposes
     */
    public $lastValues: { [fieldId: string]: any };

    /**
     * Temporary variable telling us whether this option filter's dependencies changed and should be run
     */
    public $shouldRun: boolean;
    /**
     * Holds the snap structure.  Starts with $ so angular will ignore it when parsing json
     */
    public $structure: any;
    /**
     * The most recent calculated source.  Stored for other option filters that might refer
     * to this one for it's source.
     */
    public $source: any[];

}
